import { type ComponentProps, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { createSmaulLead } from "../../api/smaul";
import PageLayout from "../../components/PageLayout";
import { PanelTitle } from "./styles";
import NoticeSection from "./sections/NoticeSection";
import CustomerFormSection from "./sections/CustomerFormSection";
import { QuickEstimateInput } from "../Initial/types";

type CustomerLocationState = {
  propertyInfo?: QuickEstimateInput;
};

export default function CustomerPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const propertyInfo = (location.state as CustomerLocationState | null)?.propertyInfo;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    if (!propertyInfo) {
      navigate("/", { replace: true });
    }
  }, [navigate, propertyInfo]);

  const handleSubmit: NonNullable<ComponentProps<"form">["onSubmit"]> = async (event) => {
    event.preventDefault();
    if (!propertyInfo || isSubmitting) {
      return;
    }

    const formData = new FormData(event.currentTarget);
    const familyName = String(formData.get("lastName") || "").trim();
    const firstName = String(formData.get("firstName") || "").trim();
    const phoneNumber = String(formData.get("phone") || "").trim();
    const email = String(formData.get("email") || "").trim();

    setErrorMessage(undefined);
    setIsSubmitting(true);

    try {
      await createSmaulLead({
        mansion_name: propertyInfo.mansionName,
        room_number: propertyInfo.roomNumber,
        family_name: familyName,
        first_name: firstName,
        phone_number: phoneNumber,
        email,
      });
      navigate("/complete");
    } catch {
      setErrorMessage("送信に失敗しました。時間をおいて再度お試しください。");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!propertyInfo) {
    return null;
  }

  return (
    <PageLayout>
      <PanelTitle>お客様情報入力</PanelTitle>
      <NoticeSection />
      <CustomerFormSection
        onSubmit={handleSubmit}
        onBack={() => navigate("/")}
        isSubmitting={isSubmitting}
        errorMessage={errorMessage}
      />
    </PageLayout>
  );
}
